import { render, staticRenderFns } from "./QuilityRx.vue?vue&type=template&id=ca69387c&"
import script from "./QuilityRx.vue?vue&type=script&lang=js&"
export * from "./QuilityRx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports